import { z } from 'zod';

const moneyDto = z.object({
  amount: z.number(),
  currency: z.enum(['GEL', 'USD', 'EUR']),
});

const orderStatusDto = z.enum([
  'pending',
  'awaiting-payment',
  'paid',
  'processing',
  'shipped',
  'delivered',
  'cancelled',
  'refunded',
]);

const paymentKindDto = z.enum([
  'cod',
  'card',
  'bog',
  'bog-card',
  'bog-apple-pay',
  'bog-google-pay',
  'bog-mobile-bank',
  'bog-loyalty',
  'bog-installment',
  'bog-bnpl',
  'tbc',
  'tbc-installment',
  'space',
  'tera',
]);

export const accountOrderSummaryDto = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  number: z.string(),
  status: orderStatusDto,
  placed_at: z.string().nullable().default(null),
  total: moneyDto,
  item_count: z.number().int().min(0),
  payment_kind: paymentKindDto,
});

export const accountOrderItemDto = z.object({
  product_id: z.union([z.string(), z.number()]).transform(String),
  name: z.string(),
  quantity: z.number().int().min(0),
  unit_price: moneyDto,
  line_total: moneyDto,
});

export const accountOrderDetailDto = accountOrderSummaryDto.extend({
  first_name: z.string(),
  last_name: z.string(),
  phone: z.string(),
  email: z.string(),
  city: z.string(),
  address: z.string(),
  notes: z.string().nullable().default(null),
  items: z.array(accountOrderItemDto),
});

export const accountOrderListDto = z.object({
  data: z.array(accountOrderSummaryDto),
  meta: z.object({
    current_page: z.number().int().min(1),
    last_page: z.number().int().min(1),
    per_page: z.number().int().min(1),
    total: z.number().int().min(0),
  }).optional(),
});

export const accountOrderDetailEnvelopeDto = z.object({
  data: accountOrderDetailDto,
});

export type AccountOrderSummaryDto = z.infer<typeof accountOrderSummaryDto>;
export type AccountOrderDetailDto = z.infer<typeof accountOrderDetailDto>;
export type AccountOrderItemDto = z.infer<typeof accountOrderItemDto>;
